module.exports = __webpack_public_path__ + "img/streamline-icon-arrow-up-1@24x24.a3d3c418.svg";